import styled, { keyframes } from "styled-components";
import { Link } from "react-router-dom";
import { fadeInLeft } from "react-animations";
import { primaryColor, primaryColorHover, bodyColor } from "../../../../../../config/constants";
import ReactTooltip from "react-tooltip";

// Keyframes
const fadeInDownAnimation = keyframes`${fadeInLeft}`;

// Styles
export const ProtocolReportDiv = styled.div`
  margin: 5px auto;
  width: 100%;
  max-width: 860px;
  height: 40px;
  display: flex;
  border-radius: 5px;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
  @media (max-width: 910px) {
    width: 85%;
    height: auto;
    flex-direction: column;
    align-items: flex-end;
    background-color: transparent;
    box-shadow: none;
    transition: all 0.5s ease-out;
  }
`;
export const ProtocolCardDiv = styled.div`
  height: 40px;
  display: flex;
  align-items: center;
  border-radius: 5px;
  background-color: #fff;
  @media (max-width: 910px) {
    width: 100%;
    position: relative;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    transition: all 0.5s ease-out;
  }
`;
export const VideoButton = styled.button`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  background-color: #fff;
  border: none;
  border-radius: 5px;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
export const ProtocolImg = styled.img`
  margin-right: 2px;
  width: 80px;
  height: 40px;
`;
export const DiagnosisMarkDiv = styled.div`
  margin-right: 15px;
  width: 30px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgb(245 125 82);
`;
export const DiagnosisMarkImg = styled.img`
  width: 20px;
  height: 20px;
`;
export const VideoButtonImg = styled.img`
  width: 23px;
  height: 23px;
`;
export const InfoImg = styled.img`
  width: 23px;
  height: 23px;
`;
export const ReactTooltipStyled = styled(ReactTooltip)`
  max-width: 500px;
  border-radius: 5px !important;
  padding: 15px !important;
`;
export const ProtocolName = styled.p`
  margin-left: 15px;
  font-size: 14px;
  color: #000;
  font-weight: 600;
  text-align: left;
  @media (max-width: 910px) {
    font-size: 10px;
  }
`;
export const ShowPrescriptionsButton = styled.button`
  padding: 0 5px;
  height: 80%;
  display: none;
  border: none;
  background: transparent;
  outline: none;
  border-left: 2px solid ${bodyColor};
  position: absolute;
  right: 0;
  cursor: pointer;
  @media (max-width: 910px) {
    display: flex;
    align-items: center;
  }
`;
export const ArrowImg = styled.img`
  width: 15px;
  height: 15px;
`;
export const ExtraInfoDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  @media (max-width: 910px) {
    margin-top: 2px;
    width: 100%;
    display: ${({ show }) => (show ? "flex" : "none")};
    animation: 0.5s ${fadeInDownAnimation};
  }
`;
export const ReportsSectionDiv = styled.div`
  width: 120px;
  display: flex;
  flex-direction: column;
  align-items: center;
  border-left: 2px dashed #ccc;
  background-color: #fff;
  @media (max-width: 910px) {
    height: 66px;
    border: none;
    box-shadow: 0 5px 15px rgb(0 0 0 / 10%);
    border-radius: 5px;
  }
`;
export const ExtraInfoText = styled.p`
  font-size: 14px;
  color: #808080;
  display: none;
  @media (max-width: 910px) {
    margin-bottom: 7px;
    display: flex;
    font-size: 12px;
  }
`;
export const SessionsDiv = styled.div`
  padding-left: 20px;
  width: 100%;
  display: flex;
  align-items: center;
  @media (max-width: 910px) {
    padding-left: 15px;
  }
`;
export const ReportsLink = styled(Link)`
  width: 35px;
  height: 35px;
  background-color: ${({ sessions }) => (sessions > 0 ? primaryColor : "#808080")};
  border-radius: 5px;
  outline: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.15s ease-in-out;
  &:hover {
    background-color: ${primaryColorHover};
  }
  @media (max-width: 910px) {
    width: 30px;
    height: 30px;
  }
`;
export const ReportsImg = styled.img`
  width: 70%;
  height: 70%;
`;
export const SessionsNumber = styled.p`
  margin-left: 18px;
  font-size: 14px;
  color: #ccc;
  @media (max-width: 910px) {
    margin-left: 10px;
  }
`;
